<template>
  <div class="business-steps">
    <div class="business-steps-wrapper" :class="huahuoPlus && 'huahuo-plus'">
      <div :key="idx" :title="item.title" class="business-steps-item" :style="stepItemStyle" v-for="(item, idx) in list">
        <div class="flex flex-col">
          <div class="flex-center">
            <div class="process-line-prev" :class="processLineClass(idx)"></div>
            <StepIcon :doing-index="index + 2" :index="idx + 1" :huahuo-plus="huahuoPlus" />
            <div class="process-line-next" :class="processLineClass(idx)"></div>
          </div>
          <div class="font-size-12 text-center mt10">
            <span :class="index + 1 == idx ? 'c-text-1 font-weight-600' : 'c-text-1'" style="position: relative">{{ nameFormat ? nameFormat(item) : item.status_desc || '-' }} </span>
          </div>
        </div>
        <div class="font-size-12 text-center mt2 business-steps-item-time" v-if="index >= idx" :style="isLiveOrder ? 'margin: 0 12px 0 12px' : ''">
          <span class="c-gray" v-if="item.is_skip">跳过</span>
          <template v-else>
            <span v-if="index <= idx">{{ formatDate(item.flow_time, 'yyyy-LL-dd HH:mm:ss', ' ') }}</span>
            <span v-else>{{ formatDate(item.flow_time) }}</span>
          </template>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { formatDate } from '@Utils/business'
import StepIcon from './StepIcon.vue'
import { CooperationEnum } from '@/constant/data'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    list: Array<any>
    cooperateTypeName: number
    index: number
    nameFormat: Function
    huahuoPlus?: boolean
  }>(),
  {
    list: () => [],
    index: 0,
    cooperateTypeName: 0,
    nameFormat: () => () => '',
    huahuoPlus: true
  }
)

const processLineClass = computed(() => {
  return idx => {
    return {
      doing: props.index + 1 === idx,
      'to-do': props.index + 1 < idx,
      done: props.index + 1 > idx
    }
  }
})
const stepItemStyle = computed(() => {
  return {
    width: `calc(100% / ${props.list.length ?? 1})`
  }
})
const isLiveOrder = computed(() => {
  return [CooperationEnum.OnlineLive, CooperationEnum.OfflineLive].includes(props.cooperateTypeName)
})
</script>

<style lang="less" scoped>
.business-steps {
  position: relative;
}
.business-steps-wrapper {
  width: 100%;
  padding: 0 24px 0;
  display: flex;
  align-items: start;

  &.huahuo-plus {
    position: relative;
    z-index: 1;
    pointer-events: none;
    padding-top: 48px;
  }
  .business-steps-item {
    min-width: 101px;
  }

  .business-steps-item-time {
    height: 36px;
  }
}
.process-line {
  &-prev,
  &-next {
    flex: 1;
    height: 2px;
    background: url('@/assets/images/step-dashed-line.svg') no-repeat;
  }

  &-prev.done,
  &-prev.doing,
  &-next.done {
    background: url('@/assets/images/step-solid-line.svg') no-repeat;
  }
}
</style>
